module.exports = __webpack_public_path__ + "assets/img/copyright-three.76947c66.png";